import React from 'react';
import {CheckCircle, Play, Users, BarChart3, Clock} from 'lucide-react';
import ContactForm from './ContactForm';

const HomePage = () => {
    return (
        <div className="min-h-screen bg-white">
            {/* Navigation */}
            <nav className="nav-header">
                <div className="logo-container">
                    <img
                        src={require('../../assets/logo.png')}
                        alt="Checklist Logo"
                        className="logo-img"
                    />
                    <span className="heading-3">Checklist</span>
                </div>
                <div className="hidden md:flex items-center gap-4">
                    <a href="#about" className="nav-link">Sobre o Produto</a>
                    <a href="#learn-more" className="nav-link">Saiba Mais</a>
                    <a href="#considerations" className="nav-link">Considerações</a>
                    <a href="#contact" className="nav-link">Fale Conosco</a>
                </div>
                <button className="btn-primary btn-primary-menu"
                        onClick={() => window.open('https://play.google.com/store/apps/details?id=com.manage4me.checklist&hl=pt-BR&ah=vwv-KZ144aR_NviKvALCp2W1Th4', '_blank')}>
                    Começar Agora
                </button>
            </nav>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="container">
                    <div className="max-w-4xl mx-auto text-center">
                        <h1 className="heading-1 mb-6">
                            Checklist Digital
                        </h1>
                        <h1 className="heading-1 mb-6">
                            O Futuro da Sua Frota
                        </h1>
                        <p className="body-large mb-8 text-secondary">
                            Agilidade, mobilidate e organização para seus serviços.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                            <button className="btn-primary flex items-center gap-2"
                                    onClick={() => window.open('https://play.google.com/store/apps/details?id=com.manage4me.checklist&hl=pt-BR&ah=vwv-KZ144aR_NviKvALCp2W1Th4', '_blank')}>
                                <CheckCircle size={20}/>
                                Começar Gratuitamente
                            </button>
                            <button
                                className="btn-secondary flex items-center gap-2"
                                onClick={() => window.open('https://www.youtube.com/watch?v=T_wLZrd3S4U', '_blank')}
                            >
                                <Play size={20}/>
                                Ver Demonstração
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section id="about" className="section-padding bg-section">
                <div className="container">
                    <div className="text-center mb-12">
                        <h2 className="heading-2 mb-4">Sobre o Produto</h2>
                        <div className="max-w-3xl mx-auto space-y-4">
                            <p className="body-large">
                                Transforme os dados da sua frota em lucros tangíveis com relatórios detalhados e
                                agilidade no atendimento.
                            </p>
                            <p className="body-large text-accent font-semibold">
                                Checklist digital: o futuro da sua frota
                            </p>
                        </div>
                    </div>

                    {/* Prestador Próximo Subsection */}
                    <div className="mb-16">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            <div className="space-y-6">
                                <h3 className="heading-2">Encontre e acione o prestador mais próximo!</h3>
                                <p className="body-large">
                                    Atenda mais rápido, economize combustível e conquiste a satisfação do cliente.
                                </p>

                                <div className="text-center space-y-4 ">
                                    <h4 className="heading-3">Disponível para Android</h4>
                                    <div className="flex items-center justify-center gap-4 ">
                                        <button className="google-btn-card"
                                            onClick={() => window.open('https://play.google.com/store/apps/details?id=com.manage4me.checklist&hl=pt-BR&ah=vwv-KZ144aR_NviKvALCp2W1Th4', '_blank')}
                                        >
                                        <img
                                            src={require('../../assets/app-store-2.png')}
                                            alt="Disponível no Google Play"
                                            className="w-48 h-auto"
                                        />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="relative">
                                <img
                                    src={require('../../assets/aboult-pic-1.png')}
                                    alt="Prestador mais próximo"
                                    className="w-full h-auto"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Gestão Digital Subsection */}
                    <div className="mb-12">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            <div className="relative order-2 lg:order-1">
                                <img
                                    src={require('../../assets/veiculo-picture2.png')}
                                    alt="Checklist Digital"
                                    className="w-full h-auto"
                                />
                            </div>

                            <div className="space-y-6 order-1 lg:order-2">
                                <h3 className="heading-2">Diga adeus ao papel e abrace o futuro da gestão de
                                    frotas!</h3>
                                <p className="body-large">
                                    Com o Checklist totalmente online, seus técnicos ganham agilidade e você, controle
                                    total na palma da sua mão. Nosso aplicativo permite o preenchimento rápido e fácil,
                                    além de fotos, assinaturas e compartilhamento de informações em tempo real.
                                </p>
                                <p className="body-large font-semibold text-accent">
                                    Experimente agora o Checklist online e veja sua frota decolar!
                                </p>

                                <div className="space-y-3">
                                    <div className="flex items-center gap-3">
                                        <CheckCircle className="text-accent" size={20}/>
                                        <span className="body-medium">Registro de fotos das avarias</span>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <CheckCircle className="text-accent" size={20}/>
                                        <span className="body-medium">Registro de assinaturas dos beneficiários</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Original Features Grid */}
                    <div className="ai-grid">
                        <div className="feature-card">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-accent-wash rounded-full">
                                    <BarChart3 className="text-accent" size={24}/>
                                </div>
                                <h3 className="heading-3">Relatórios Detalhados</h3>
                            </div>
                            <p className="body-medium">
                                Transforme dados da sua frota em insights valiosos com relatórios completos e análises
                                precisas.
                            </p>
                        </div>

                        <div className="feature-card">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-accent-wash rounded-full">
                                    <Clock className="text-accent" size={24}/>
                                </div>
                                <h3 className="heading-3">Agilidade no Atendimento</h3>
                            </div>
                            <p className="body-medium">
                                Otimize seus processos e reduza o tempo de resposta com automação inteligente e
                                organização eficiente.
                            </p>
                        </div>

                        <div className="feature-card">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-2 bg-accent-wash rounded-full">
                                    <Users className="text-accent" size={24}/>
                                </div>
                                <h3 className="heading-3">Gestão da Equipe</h3>
                            </div>
                            <p className="body-medium">
                                Monitore sua equipe externa, acompanhe disponibilidade e progresso dos serviços em tempo
                                real.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Learn More Section */}
            <section id="learn-more" className="section-padding">
                <div className="container">
                    <div className="text-center mb-12">
                        <h2 className="heading-2 mb-4">Saiba Mais</h2>
                        <p className="body-large mb-8">
                            Assista aos vídeos tutoriais e aprenda como usar todas as funcionalidades do Checklist
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Video 1 - Login */}
                        <div className="feature-card">
                            <div className="mb-4">
                                <iframe
                                    className="w-full aspect-video rounded-lg"
                                    src="https://www.youtube.com/embed/JSgB--uffws?si=DzRGjacneUugDuLk"
                                    title="Login - Checklist"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                            <h3 className="heading-3 mb-3">Login</h3>
                            <p className="body-medium">
                                Neste vídeo você verá como fazer login e se registrar caso ainda não tenha uma conta.
                            </p>
                        </div>

                        {/* Video 2 - Página inicial */}
                        <div className="feature-card">
                            <div className="mb-4">
                                <iframe
                                    className="w-full aspect-video rounded-lg"
                                    src="https://www.youtube.com/embed/1jv-YqWG_Zk?si=7kJ8NPj3iFgeiWZi"
                                    title="Página inicial - Checklist"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                            <h3 className="heading-3 mb-3">Página inicial</h3>
                            <p className="body-medium">
                                Neste vídeo demonstra a interface inicial do aplicativo "Checklist", esta é a sua
                                central de controle, onde você acompanha os serviços em andamento.
                            </p>
                        </div>

                        {/* Video 3 - Novo Serviço */}
                        <div className="feature-card">
                            <div className="mb-4">
                                <iframe
                                    className="w-full aspect-video rounded-lg"
                                    src="https://www.youtube.com/embed/X7Gt_KS_ipw?si=fe49n_km7eVUgPLX"
                                    title="Novo Serviço - Checklist"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                            <h3 className="heading-3 mb-3">Novo Serviço</h3>
                            <p className="body-medium">
                                Neste vídeo vamos mostrar passo a passo como se cria um novo serviço no aplicativo.
                            </p>
                        </div>

                        {/* Video 4 - Visualização de Relatórios */}
                        <div className="feature-card">
                            <div className="mb-4">
                                <iframe
                                    className="w-full aspect-video rounded-lg"
                                    src="https://www.youtube.com/embed/97N20keH9ZY?si=hVqetsLW-zijLIRK"
                                    title="Visualização de Relatórios - Checklist"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </div>
                            <h3 className="heading-3 mb-3">Visualização de Relatórios</h3>
                            <p className="body-medium">
                                Este vídeo mostra como você pode acessar os relatórios dos serviços.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Considerations Section */}
            <section id="considerations" className="section-padding bg-section">
                <div className="container">
                    <div className="text-center mb-12">
                        <h2 className="heading-2 mb-4">Considerações</h2>
                        <p className="body-large mb-8">
                            Expanda sua capacidade de atendimento e assuma o controle total da sua equipe externa
                        </p>
                    </div>


                        <div className="space-y-6">
                            <div className="feature-card">
                                <h3 className="heading-3 mb-3">Monitoramento em Tempo Real</h3>
                                <p className="body-medium">
                                    Com o aplicativo Checklist, você monitora a frota, a disponibilidade dos prestadores
                                    e o progresso dos serviços em tempo real. Antecipe problemas com análises precisas e
                                    otimize suas operações.
                                </p>
                            </div>

                            <div className="feature-card">
                                <h3 className="heading-3 mb-3">Gestão Eficiente da Equipe Externa</h3>
                                <p className="body-medium">
                                    Acompanhe a frota, a disponibilidade dos prestadores e o progresso dos serviços em
                                    tempo real com ferramentas intuitivas e poderosas.
                                </p>
                            </div>


                        <div className="feature-card h-fit">
                            <h3 className="heading-3 mb-3">Informações Organizadas</h3>
                            <p className="body-medium mb-4">
                                Acesse todas as informações dos seus serviços de forma rápida e organizada
                            </p>
                            <ul className="space-y-2 body-small">
                                <li className="flex items-center gap-2">
                                    <CheckCircle size={16} className="text-accent"/>
                                    Mensagens automaticamente anexadas
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle size={16} className="text-accent"/>
                                    Checklists e fotos dos atendimentos
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle size={16} className="text-accent"/>
                                    Assinaturas de clientes e registros
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle size={16} className="text-accent"/>
                                    Tempo de atendimento em um só lugar
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="section-padding">
                <div className="container">
                    <div className="text-center mb-12">
                        <h2 className="heading-2 mb-4">Fale Conosco</h2>
                        <p className="body-large">
                            Entre em contato para saber mais sobre o Checklist
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-12 items-start">
                        <div className="space-y-6">
                            <div className="feature-card">
                                <h4 className="heading-3 mb-3">Pronto para começar?</h4>
                                <p className="body-medium mb-4">
                                    Transforme a gestão da sua frota hoje mesmo com nossa solução digital completa.
                                </p>
                                <button className="btn-primary w-full"
                                        onClick={() => window.open('https://play.google.com/store/apps/details?id=com.manage4me.checklist&hl=pt-BR&ah=vwv-KZ144aR_NviKvALCp2W1Th4', '_blank')}>
                                    Começar Gratuitamente
                                </button>
                            </div>

                            <div className="feature-card">
                                <h4 className="heading-3 mb-3">Por que escolher o Checklist?</h4>
                                <ul className="space-y-2 body-medium">
                                    <li className="flex items-center gap-2">
                                        <CheckCircle size={16} className="text-accent"/>
                                        Controle total da sua frota
                                    </li>
                                    <li className="flex items-center gap-2">
                                        <CheckCircle size={16} className="text-accent"/>
                                        Relatórios detalhados em tempo real
                                    </li>
                                    <li className="flex items-center gap-2">
                                        <CheckCircle size={16} className="text-accent"/>
                                        Interface intuitiva e fácil de usar
                                    </li>
                                    <li className="flex items-center gap-2">
                                        <CheckCircle size={16} className="text-accent"/>
                                        Suporte técnico especializado
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <ContactForm/>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-section border-t border-border-light">
                <div className="container pad-lg">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                        <div className="logo-container">
                            <img
                                src={require('../../assets/logo.png')}
                                alt="Checklist Logo"
                                className="logo-img"
                            />
                            <div>
                                <span className="heading-3">Checklist</span>
                                <p className="body-small">Checklist digital: o futuro da sua frota</p>
                            </div>
                        </div>

                        <div className="flex flex-col md:flex-row items-center gap-4">
                            <a href="#about" className="nav-link">Sobre</a>
                            <a href="#learn-more" className="nav-link">Saiba Mais</a>
                            <a href="#considerations" className="nav-link">Considerações</a>
                            <a href="#contact" className="nav-link">Contato</a>
                        </div>
                    </div>

                    <div className="border-t border-border-light mt-8 pt-6 text-center">
                        <p className="body-small">
                            © 2024 Checklist. Transformando a gestão de frotas com tecnologia digital.
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default HomePage;